// src/components/ContactForm.js
import { useState } from "react";
import "./styles/Kontakt.css";

function ContactForm() {
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("submitting");

    const form = e.target;
    const data = Object.fromEntries(new FormData(form));

    try {
      const res = await fetch("https://formspree.io/f/xwvnwdjw", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  }

  if (status === "success") {
    return (
      <div className="form-success">
        <p>Täname! Teie sõnum on saadetud. Võtame teiega peagi ühendust.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-group">
        <label htmlFor="name">Nimi</label>
        <input type="text" id="name" name="name" required />
      </div>

      <div className="form-group">
        <label htmlFor="email">E-post</label>
        <input type="email" id="email" name="email" required />
      </div>

      <div className="form-group">
        <label htmlFor="phone">Telefon <span className="optional">(vabatahtlik)</span></label>
        <input type="tel" id="phone" name="phone" />
      </div>

      <div className="form-group">
        <label htmlFor="message">Sõnum</label>
        <textarea id="message" name="message" rows="5" required />
      </div>

      {status === "error" && (
        <p className="form-error">Midagi läks valesti. Palun proovige uuesti.</p>
      )}

      <button type="submit" className="submit-btn" disabled={status === "submitting"}>
        {status === "submitting" ? "Saadan..." : "Saada sõnum"}
      </button>
    </form>
  );
}

export default ContactForm;
